module.exports = __webpack_public_path__ + "img/img16.bea6aa2b.png";